import React from "react";
import HomeBanner from "../../../components/sections/front/Home/HomeBanner";
import ImportantDatesSection from "../../../components/sections/front/Home/ImportantDatesSection";
import ScholarshipSection from "../../../components/sections/front/Home/ScholarshipSection";
import ScholarshipStatisticsSection from "../../../components/sections/front/Home/ScholarshipStatisticsSection";
import ProjectSection from "../../../components/sections/front/Home/ProjectSection";
import WhyWeGiveSection from "../../../components/sections/front/Home/WhyWeGiveSection";
import TestimonialSection from "../../../components/sections/front/Home/TestimonialSection";
import OurPartners from "../../../components/sections/front/Common/OurPartners";
import { Helmet } from "react-helmet-async";
import { useBanner } from "../../../providers/BannerProviders";

const Home = () => {
  const { data } = useBanner();
  const homeBanner = data?.data?.find((item) => item?.bannerType === "home");

  return (
    <>
      {homeBanner && (
        <Helmet>
          <title>{homeBanner.seoTitle}</title>
          <meta
            name="description"
            property="og:description"
            content={homeBanner.seoDescription}
          />
          <meta
            name="keywords"
            property="og:keywords"
            content={homeBanner.seoKeyword}
          />
          <meta
            name="author"
            property="og:author"
            content={homeBanner.seoAuthor}
          />
          <meta
            property="og:image"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
          <meta
            property="og:image:url"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
          <meta
            property="og:image:secure_url"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
        </Helmet>
      )}
      <HomeBanner />
      <ImportantDatesSection />
      <ScholarshipSection />
      <ScholarshipStatisticsSection />
      <ProjectSection />
      <WhyWeGiveSection />
      <TestimonialSection />
      <OurPartners />
    </>
  );
};

export default Home;
